import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useBlocker } from 'react-router-dom';

import { useDirtyContext } from './DirtyContext';

const DirtyNavigationBlocker = () => {
    const intl = useIntl();
    const { isDirty, clearAllDirtySources, skipNextBlockRef } = useDirtyContext();

    const blocker = useBlocker(({ currentLocation, nextLocation }) => {
        if (skipNextBlockRef.current) return false;
        if (!isDirty || currentLocation.pathname === nextLocation.pathname) return false;

        const message = intl.formatMessage({
            id: 'block-action.native-confirm',
            defaultMessage:
                'You have unsaved changes. If you continue, every unsaved change will be lost.',
        });
        // eslint-disable-next-line no-alert
        const confirmed = window.confirm(message);
        if (confirmed) {
            clearAllDirtySources();
            return false;
        }
        return true;
    });

    useEffect(() => {
        if (blocker.state === 'blocked') {
            blocker.reset();
        }
    }, [blocker]);

    return null;
};

export default DirtyNavigationBlocker;
